import { FlaskConical } from 'lucide-react';
import { CollectionAdmin } from './_P1Common';

export default function AdminABTesting() {
  return (
    <CollectionAdmin
      path="ab-testing"
      title="A/B testiranje"
      subtitle="Eksperimenti nad naslovima, CTA i slikama"
      icon={FlaskConical}
      testid="admin-ab-testing"
      fields={[
        { key: 'name', label: 'Naziv eksperimenta' },
        { key: 'target_type', label: 'Što se testira (headline/cta/image)' },
        { key: 'variant_a', label: 'Varijanta A', type: 'textarea' },
        { key: 'variant_b', label: 'Varijanta B', type: 'textarea' },
        { key: 'traffic_pct', label: 'Promet (%)', type: 'number' },
        { key: 'active', label: 'Aktivan', type: 'checkbox' },
      ]}
    />
  );
}
